export default function KakaoLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <g clipPath="url(#clip0_11300_37278)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.50002 0.599609C4.52917 0.599609 0.5 3.71257 0.5 7.55189C0.5 9.93963 2.0584 12.0446 4.43152 13.2966L3.43303 16.9441C3.34481 17.2664 3.71341 17.5233 3.99646 17.3365L8.37334 14.4478C8.7427 14.4835 9.11808 14.5043 9.50002 14.5043C14.4705 14.5043 18.4999 11.3914 18.4999 7.55189C18.4999 3.71257 14.4705 0.599609 9.50002 0.599609Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_11300_37278">
          <rect width="17.9999" height="18" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
